import React, { PropTypes, Component } from 'react';
import classnames from 'classnames';

import './style.scss';

export class PageSelector extends Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handle = this.handleInputChange.bind(this);
    this.handlePrevClick = this.handlePrevClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.onPageUpdate(Number(this.refs.input.value), this.props.pagesCount);
  }

  handleInputChange(event) {
    this.props.onPossiblePageUpdate(Number(event.target.value));
  }

  handlePrevClick() {
    this.props.onPrevClick(this.props.possiblePage);
  }

  handleNextClick() {
    this.props.onNextClick(this.props.possiblePage);
  }

  render() {
    const prevClassName = classnames({
      'prev': true,
      'is-inactive': !this.props.isPrevActive
    });

    const nextClassName = classnames({
      'next': true,
      'is-inactive': !this.props.isNextActive
    });

    return (
      <div className="PageSelector">
        <a className={prevClassName} onClick={this.handlePrevClick}>{__('members.paging.previous')}</a>

        <div className="numbers">
          <span className="current">
            <form onSubmit={this.handleSubmit}>
              <input type="number" ref="input" value={this.props.possiblePage || ""} onChange={this.handleInputChange} />
            </form>
          </span>
          {__('members.paging.separator')} {this.props.pagesCount}
        </div>

        <a className={nextClassName} onClick={this.handleNextClick}>{__('members.paging.next')}</a>
      </div>
    );
  }
}

PageSelector.propTypes = {
  isPrevActive: PropTypes.bool,
  isNextActive: PropTypes.bool,
  possiblePage: PropTypes.number,
  pagesCount: PropTypes.number,
  onNextClick: PropTypes.func,
  onPrevClick: PropTypes.func,
  onPossiblePageUpdate: PropTypes.func,
  onPageUpdate: PropTypes.func
};

export default PageSelector;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/PageSelector/index.js
 **/